/**
 * 枕頭型號選項 - 共用常數
 * 用於枕頭商品搜尋列表與新增編輯頁面的下拉選單
 */

export const PILLOW_MODEL_OPTIONS = [
    // 嬰兒枕
    { value: '【嬰兒枕】型號Ｂ', label: '【嬰兒枕】型號Ｂ', category: '嬰兒枕' },
    
    // 兒童枕
    { value: '【兒童枕】型號Ｃ', label: '【兒童枕】型號Ｃ', category: '兒童枕' },
    
    // 成人枕 1 (6公分)
    { value: '型號6A：6公分 短弧度', label: '【成人枕】1 型號6A：6公分 短弧度', category: '成人枕' },
    { value: '型號6B：6公分 中弧度', label: '【成人枕】1 型號6B：6公分 中弧度', category: '成人枕' },
    
    // 成人枕 2 (6.5公分 - 半張墊片)
    { value: '型號6.5A：6.5公分 短弧度', label: '【成人枕】2 型號6.5A：6.5公分 短弧度 (半張墊片)', category: '成人枕' },
    { value: '型號6.5B：6.5公分 中弧度', label: '【成人枕】2 型號6.5B：6.5公分 中弧度 (半張墊片)', category: '成人枕' },
    
    // 成人枕 3 (6.5公分 - 一整張墊片)
    { value: '型號6.5AA：6.5公分 短弧度', label: '【成人枕】3 型號6.5AA：6.5公分 短弧度 (一對墊片)', category: '成人枕' },
    { value: '型號6.5BB：6.5公分 中弧度', label: '【成人枕】3 型號6.5BB：6.5公分 中弧度 (一對墊片)', category: '成人枕' },
    
    // 成人枕 4 (6.5公分 - 對折墊片)
    { value: '型號6.5A2：6.5公分 短弧度', label: '【成人枕】4 型號6.5A2：6.5公分 短弧度 (對折墊片)', category: '成人枕' },
    { value: '型號6.5B2：6.5公分 中弧度', label: '【成人枕】4 型號6.5B2：6.5公分 中弧度 (對折墊片)', category: '成人枕' },
    
    // 7公分系列
    { value: '型號7A：7公分 短弧度', label: '【成人枕】型號7A：7公分 短弧度', category: '成人枕' },
    { value: '型號7B：7公分 中弧度', label: '【成人枕】型號7B：7公分 中弧度', category: '成人枕' },
    { value: '型號7C：7公分 長弧度', label: '【成人枕】型號7C：7公分 長弧度', category: '成人枕' },
    
    // 成人枕 5 (7.5公分 - 半張墊片)
    { value: '型號7.5A：7.5公分 短弧度', label: '【成人枕】5 型號7.5A：7.5公分 短弧度 (半張墊片)', category: '成人枕' },
    { value: '型號7.5B：7.5公分 中弧度', label: '【成人枕】5 型號7.5B：7.5公分 中弧度 (半張墊片)', category: '成人枕' },
    { value: '型號7.5C：7.5公分 長弧度', label: '【成人枕】5 型號7.5C：7.5公分 長弧度 (半張墊片)', category: '成人枕' },
    
    // 成人枕 6 (7.5公分 - 一整張墊片)
    { value: '型號7.5AA：7.5公分 短弧度', label: '【成人枕】6 型號7.5AA：7.5公分 短弧度 (一對墊片)', category: '成人枕' },
    { value: '型號7.5BB：7.5公分 中弧度', label: '【成人枕】6 型號7.5BB：7.5公分 中弧度 (一對墊片)', category: '成人枕' },
    { value: '型號7.5CC：7.5公分 長弧度', label: '【成人枕】6 型號7.5CC：7.5公分 長弧度 (一對墊片)', category: '成人枕' },
    
    // 成人枕 7 (7.5公分 - 對折墊片)
    { value: '型號7.5A2：7.5公分 短弧度', label: '【成人枕】7 型號7.5A2：7.5公分 短弧度 (對折墊片)', category: '成人枕' },
    { value: '型號7.5B2：7.5公分 中弧度', label: '【成人枕】7 型號7.5B2：7.5公分 中弧度 (對折墊片)', category: '成人枕' },
    { value: '型號7.5C2：7.5公分 長弧度', label: '【成人枕】7 型號7.5C2：7.5公分 長弧度 (對折墊片)', category: '成人枕' },
    
    // 8公分系列
    { value: '型號8A：8公分 短弧度', label: '【成人枕】型號8A：8公分 短弧度', category: '成人枕' },
    { value: '型號8B：8公分 中弧度', label: '【成人枕】型號8B：8公分 中弧度', category: '成人枕' },
    { value: '型號8C：8公分 長弧度', label: '【成人枕】型號8C：8公分 長弧度', category: '成人枕' },
    
    // 9公分系列
    { value: '型號9A：9公分 短弧度', label: '【成人枕】型號9A：9公分 短弧度', category: '成人枕' },
    { value: '型號9B：9公分 中弧度', label: '【成人枕】型號9B：9公分 中弧度', category: '成人枕' },
    { value: '型號9C：9公分 長弧度', label: '【成人枕】型號9C：9公分 長弧度', category: '成人枕' },
    
    // 10公分系列
    { value: '型號10B：10公分 中弧度', label: '【成人枕】型號10B：10公分 中弧度', category: '成人枕' },
    { value: '型號10C：10公分 長弧度', label: '【成人枕】型號10C：10公分 長弧度', category: '成人枕' },
    
    // 成人枕 8 (10.5公分 - 半張墊片)
    { value: '型號10.5B：10.5公分 中弧度', label: '【成人枕】8 型號10.5B：10.5公分 中弧度 (半張墊片)', category: '成人枕' },
    { value: '型號10.5C：10.5公分 長弧度', label: '【成人枕】8 型號10.5C：10.5公分 長弧度 (半張墊片)', category: '成人枕' },
    
    // 成人枕 9 (10.5公分 - 一整張墊片)
    { value: '型號10.5BB：10.5公分 中弧度', label: '【成人枕】9 型號10.5BB：10.5公分 中弧度 (一對墊片)', category: '成人枕' },
    { value: '型號10.5CC：10.5公分 長弧度', label: '【成人枕】9 型號10.5CC：10.5公分 長弧度 (一對墊片)', category: '成人枕' },
    
    // 成人枕 10 (10.5公分 - 對折墊片)
    { value: '型號10.5B2：10.5公分 中弧度', label: '【成人枕】10 型號10.5B2：10.5公分 中弧度 (對折墊片)', category: '成人枕' },
    { value: '型號10.5C2：10.5公分 長弧度', label: '【成人枕】10 型號10.5C2：10.5公分 長弧度 (對折墊片)', category: '成人枕' },
];

/**
 * 取得枕頭型號分類列表
 * @returns {string[]} 分類名稱陣列
 */
export const getPillowModelCategories = () => {
    const categories = [...new Set(PILLOW_MODEL_OPTIONS.map(option => option.category))];
    return categories;
};

/**
 * 依分類取得枕頭型號選項
 * @param {string} category - 分類名稱
 * @returns {Array} 該分類的型號選項
 */
export const getPillowModelsByCategory = (category) => {
    if (!category) return PILLOW_MODEL_OPTIONS;
    return PILLOW_MODEL_OPTIONS.filter(option => option.category === category);
};

export default PILLOW_MODEL_OPTIONS;
